@media only screen and (min-width: 576px) and (max-width: 768px) {
  .page {
    width: 80%;
  }
}

@media only screen and (min-width: 320px) and (max-width: 576px) {
  .page {
    width: 100%;
  }
}

.page {
  width: 100%;
  max-width: 768px;
}
@media (min-width: 768px) {
  .page {
    width: 50%;
    max-width: 768px;
    display: flex;
    align-items: center;
    margin: auto;
    background-color: var(--background);
  }
}
